import {
  classifyUrlSnapshotDelta,
  type ExplorationUrlSnapshot,
} from '../lib/explorationUrlParams';
import type { ExplorationState } from '../types/exploration';

export type ExplorationUrlPushPlan = 'none' | 'debounced-replace' | 'push' | 'replace';

export function planExplorationUrlPush(
  prev: ExplorationUrlSnapshot | null,
  next: ExplorationUrlSnapshot,
  urlHistoryWrite: ExplorationState['urlHistoryWrite'] = null
): ExplorationUrlPushPlan {
  if (urlHistoryWrite === 'none') return 'none';
  if (urlHistoryWrite === 'replace') return 'replace';
  if (urlHistoryWrite === 'push') return 'push';

  const baseline = prev ?? next;
  const delta = classifyUrlSnapshotDelta(baseline, next);
  if (delta === 'none') return 'none';
  if (delta === 'search-only') return 'debounced-replace';
  return 'push';
}

export function shouldReplaceExplorationUrlPush(
  plan: ExplorationUrlPushPlan
): boolean | null {
  if (plan === 'none') return null;
  return plan === 'debounced-replace' || plan === 'replace';
}
